import { Box, Typography } from '@mui/material';
import { RESOURCE_NOT_FOUND } from '../../constants';

export const NotFound = () => {
  return (
    <Box>
      <Typography variant="h4">{RESOURCE_NOT_FOUND}</Typography>
    </Box>
  );
};
